export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// The API returns naive datetimes that already represent Mountain-Time (MST)
// calendar dates, so read Y/M/D straight from the string. Converting through
// the viewer's browser timezone (or UTC) could shift the displayed date a day.
export const parseYmd = (iso) => {
    if (!iso) return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
    return m ? { year: +m[1], month: +m[2] - 1, day: +m[3] } : null;
};

export const formatBenefitYear = (start, end) => {
    const s = parseYmd(start);
    const e = parseYmd(end);
    if (!s || !e) return "—";
    return s.year === e.year
        ? `${MONTHS[s.month]} – ${MONTHS[e.month]} ${e.year}`
        : `${MONTHS[s.month]} ${s.year} – ${MONTHS[e.month]} ${e.year}`;
};

export const formatDate = (iso) => {
    const d = parseYmd(iso);
    return d ? `${MONTHS[d.month]} ${d.day}, ${d.year}` : "—";
};

export const formatIsoDate = (iso) => {
    const d = parseYmd(iso);
    return d ? `${d.year}-${String(d.month + 1).padStart(2, "0")}-${String(d.day).padStart(2, "0")}` : "";
};
